import { render, staticRenderFns } from "./BrigadadPersonas.vue?vue&type=template&id=22064757&"
import script from "./BrigadadPersonas.vue?vue&type=script&lang=js&"
export * from "./BrigadadPersonas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports